/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  titleHead: {
    color: '#342D3D',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    marginBottom: '25px',
    [theme.breakpoints.down('md')]: {
      padding: '0 15px',
    },
    '& h1': {
      fontWeight: '500',
      fontSize: '16px',
      [theme.breakpoints.down('md')]: {
        marginBottom: '25px',
      },
    },
  },
  '@media (min-width: 960px)': {
    titleHead: {
      flexWrap: 'nowrap',
      alignItems: 'center',
      flexDirection: 'row',
      marginBottom: '24px',
      '& h1': {
        fontSize: '1.5rem',
        '&:after': {
          height: '0',
          background: 'transparent',
        },
      },
    },
  },

  // Accordion CSS
  accordionContainer: {
    [theme.breakpoints.up('md')]: {
      border: '1px solid #CED1D6',
    },
    margin: ' 0 0 5px !important',
    [theme.breakpoints.down('xs')]: {
      marginBottom: '16px !important',
    },
    overflow: 'hidden',
    color: '#342D3D',
    '&:before': {
      background: 'transparent',
      display: 'none',
    },
  },
  accordionTitleHead: {
    background: '#F8F8F8',
    color: '#342D3D',
    padding: '4px 15px',
    '& > div': {
      margin: '0 !important',
    },
    '& $accordionHeading': {
      fontSize: '16px',
      fontWeight: '600',
    },
    '& svg': {
      color: '#342D3D',
      fontSize: '27px',
    },
  },
  accordionHeading: {
    display: 'flex',
    flexBasis: 'auto',
    width: '100%',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  accordianHeadingItemImage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  accordianHeadingItem: {
    padding: '5px',
    display: 'flex',
    flexDirection: 'column',
  },
  strongText: {
    fontSize: '18px',
    fontWeight: '600',
  },
  accordionDetails: {
    padding: '10px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  btnCls: {
    background: theme.palette.primary.main,
    padding: '12px 40px',
    borderRadius: '4px',
    textTransform: 'none',
    whiteSpace: 'nowrap',
  },
  errorContainer: {
    paddingLeft: '24px',
    fontSize: '14px',
    fontWeight: '500',
  },
  errorIconCls: {
    margin: '10px 0px 0px',
  },
  Title: {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '16px',
  },
  errCls: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#DF2C2C',
  },
  iconCls: {
    width: '15px',
    height: '15px',
  },
  errorNewCls: {
    marginTop: '14px',
    marginRight: '-50px',
  },
  adgmAlert: {
    width: '100%',
    display: 'block',
  },

  '@media (max-width: 767px)': {
    titleHead: {
      flexWrap: 'wrap',
    },

    // Accordion CSS
    accordionTitleHead: {
      minHeight: '48px !important',
      '& > div': {
        padding: '0',
      },
    },
  },
  '@media (min-width: 768px)': {
    titleHead: {
      padding: '16px 24px',
      '& h1': {
        fontSize: '20px',
      },
    },
    // Accordion CSS
    accordionContainer: {
      margin: '0 0 16px !important',
    },
    accordionTitleHead: {
      padding: '16px 24px',
      '& $accordionHeading': {
        fontSize: '20px',
      },
      '& svg': {
        fontSize: '27px',
      },
    },
  },
});

export default styles;
